import { gql } from '@apollo/client';

export const signInAuditListAttributes = gql`
  {
    _id
    userId
    usernameEntered
    app
    outcome
    ip
    userAgent
    createdAt
  }
`;

export const allSignInAuditForAdminQuery = gql`
  query AllSignInAuditForAdmin(
    $first: Int
    $after: String
    $filters: SignInAuditFiltersForAdmin
    $sortBy: [SortBy]
  ) {
    allSignInAuditForAdmin(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node ${signInAuditListAttributes}
      }
    }
  }
`;

export const extractSignInAuditForAdmin = (data) =>
  data && data.allSignInAuditForAdmin;

export const signInStatsForAdminQuery = gql`
  query SignInStatsForAdmin($filters: SignInStatsFiltersForAdmin!) {
    signInStatsForAdmin(filters: $filters) {
      totalAttempts
      repeatedFailures {
        usernameEntered
        count
      }
      failuresByIp {
        ip
        count
      }
      rateLimitedCount
      failuresThenSuccess {
        userId
        usernameEntered
        ip
        failureCount
        createdAt
      }
      failuresThenSuccessCount
      newIpSuccesses {
        userId
        usernameEntered
        ip
        createdAt
      }
      newIpSuccessesCount
      truncated
    }
  }
`;

export const userSecurityStatsForAdminQuery = gql`
  query UserSecurityStatsForAdmin {
    userSecurityStatsForAdmin {
      totalUsers
      mfaOn
      mfaOff
      resetRequired
    }
  }
`;

export const OUTCOME_COLORS = {
  SUCCESS: 'green',
  SIGN_UP: 'green',
  MAGIC_LINK_SUCCESS: 'green',
  GOOGLE_SUCCESS: 'green',
  CHALLENGE_SENT: 'blue',
  FAILED_PASSWORD: 'red',
  FAILED_2FA: 'red',
  RATE_LIMITED: 'volcano',
  RESET_REQUIRED: 'orange',
  PERMISSION_DENIED: 'orange',
};
